var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 32,
    viewBox: "0 0 120 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9809 4.7054V16.0914L19.4806 12.5993L14.9815 16.0914V4.7054L19.4806 1.21327L23.9809 4.7054ZM5.66904 23.3172L1.16992 26.8093V15.4232L5.66904 11.9311V23.3172ZM26.3869 11.3872H26.3857V19.8309L19.4806 25.1892L12.5754 19.8309V11.3872V6.57279L8.07508 10.0649V21.4509L8.10136 21.4298V21.9562L19.4806 30.7867L30.8598 21.9562V21.4298L30.886 21.4509V10.0649L26.3869 6.57279V11.3872ZM33.2921 23.3172V11.9311L37.7924 15.4232V26.8093L33.2921 23.3172Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5484 14.0022C53.5484 15.3088 52.8325 16.0928 51.3053 16.0928H48.7758V11.9591H51.3053C52.8325 11.9591 53.5484 12.7669 53.5484 14.0022ZM44.6953 8.58568V25.2629H48.7758V18.9674H49.7542L53.2382 25.2629H57.8437L53.9779 18.6585C56.5551 17.8983 57.7005 15.9265 57.7005 13.8359C57.7005 10.9376 55.6483 8.58568 51.5439 8.58568H44.6953Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.291 18.6348C73.291 14.4298 70.2843 11.8166 66.3709 11.8166C62.4812 11.8166 59.4507 14.4298 59.4507 18.6348C59.4507 22.8397 62.4096 25.4529 66.3231 25.4529C70.2366 25.4529 73.291 22.8397 73.291 18.6348ZM63.6028 18.6348C63.6028 16.3779 64.8914 15.3326 66.3709 15.3326C67.8026 15.3326 69.1389 16.3779 69.1389 18.6348C69.1389 20.8679 67.7788 21.937 66.3231 21.937C64.8436 21.937 63.6028 20.8679 63.6028 18.6348Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6445 18.6348C74.6445 22.8397 77.4126 25.4529 81.3261 25.4529C84.6668 25.4529 87.0292 23.5287 87.7213 20.464H83.3783C83.0203 21.4381 82.376 21.9845 81.2545 21.9845C79.7988 21.9845 78.7966 20.8441 78.7966 18.6348C78.7966 16.4254 79.7988 15.2851 81.2545 15.2851C82.376 15.2851 83.0442 15.879 83.3783 16.8055H87.7213C87.0292 13.6459 84.6668 11.8166 81.3261 11.8166C77.4126 11.8166 74.6445 14.4536 74.6445 18.6348Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.904 25.2629H93.9845V12.0066H89.904V25.2629ZM91.9561 10.6288C93.3879 10.6288 94.3663 9.65473 94.3663 8.44314C94.3663 7.20779 93.3879 6.23376 91.9561 6.23376C90.5005 6.23376 89.5221 7.20779 89.5221 8.44314C89.5221 9.65473 90.5005 10.6288 91.9561 10.6288Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9416 25.2629H101.022V18.516V15.3563V11.8404H107.847V8.58568H96.9416V25.2629Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.992 25.2629H114.072V12.0066H109.992V25.2629ZM112.044 10.6288C113.475 10.6288 114.454 9.65473 114.454 8.44314C114.454 7.20779 113.475 6.23376 112.044 6.23376C110.588 6.23376 109.61 7.20779 109.61 8.44314C109.61 9.65473 110.588 10.6288 112.044 10.6288Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.942 15.8434V19.0466H101.039L102.043 16.6575C102.254 16.1551 102.661 15.8434 103.103 15.8434H106.942Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.4808,
    y1: -16.8061,
    x2: 19.4808,
    y2: 34.3064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.373822,
    stopColor: "#B36EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4876FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 98.8545,
    y1: 17.4448,
    x2: 113.965,
    y2: 17.4448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B36EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#4876FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a322c1994f06c5a5a2b90103eca72708.svg";
export { ForwardRef as ReactComponent };